import styled from 'styled-components'

export const DoughnutChartWrapper = styled.div`
	position: relative;
	height: 100%;
	width: 100%;
`
